import React from 'react';
import { FaEnvelope, FaFacebookF, FaGoogle, FaInstagram, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import useSiteContent from '../../hooks/useSiteContent';
import { siteLinks } from '../../content/siteContent';

const socialLinks = [
  { href: siteLinks.instagramUrl, label: 'Instagram', icon: FaInstagram },
  { href: siteLinks.googleUrl, label: 'Google', icon: FaGoogle },
  { href: siteLinks.facebookUrl, label: 'Facebook', icon: FaFacebookF },
];

export default function FooterBar() {
  const { siteContent } = useSiteContent();

  return (
    <footer className="site-footer">
      <div className="site-footer__container">
        <div className="site-footer__about">
          <h3>{siteContent.header.brand}</h3>
          <p>{siteContent.footer.text}</p>
          <div className="site-footer__socials">
            {socialLinks.map(({ href, label, icon: Icon }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
                <Icon />
              </a>
            ))}
          </div>
        </div>

        <div className="site-footer__details">
          <h4>{siteContent.contact.infoTitle}</h4>
          <a href={siteLinks.emailHref}>
            <FaEnvelope />
            <span>{siteLinks.email}</span>
          </a>
          <a href={siteLinks.phoneHref}>
            <FaPhoneAlt />
            <span>{siteLinks.phone}</span>
          </a>
          <a href={siteLinks.mapsUrl} target="_blank" rel="noopener noreferrer">
            <FaMapMarkerAlt />
            <span>
              {siteLinks.address1}
              <br />
              {siteLinks.address2}
            </span>
          </a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>
          © 2026 {siteContent.header.brand}. {siteContent.footer.rights}
        </span>
        <span>{siteContent.contact.hours}</span>
      </div>
    </footer>
  );
}
